<template>
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold mb-8 text-center text-gray-800">{{ $t('floorPlan.title') }}</h2>
      <p class="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
        {{ $t('floorPlan.description') }}
      </p>
      
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <!-- Floor Plan Image -->
        <div class="lg:col-span-2">
          <FloorPlanImage
            :plan-image="floorPlan.planImage"
            :rooms="floorPlan.rooms"
            @room-selected="handleRoomSelected"
            :selected-room-id="selectedRoomId"
          />
        </div>
        
        <!-- Room Detail Panel -->
        <div class="lg:col-span-1">
          <RoomDetailPanel
            v-if="selectedRoom"
            :room="selectedRoom"
            @close="handleRoomDeselected"
          />
          <div
            v-else
            class="bg-gray-50 rounded-lg p-8 text-center text-gray-500"
          >
            <svg class="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
            </svg>
            <p class="text-lg">{{ $t('floorPlan.clickRoom') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import FloorPlanImage from './FloorPlanImage.vue';
import RoomDetailPanel from './RoomDetailPanel.vue';

const props = defineProps({
  floorPlan: {
    type: Object,
    required: true
  }
});

const selectedRoomId = ref(null);

const selectedRoom = computed(() => {
  if (!selectedRoomId.value) return null;
  return props.floorPlan.rooms.find(room => room.id === selectedRoomId.value);
});

const handleRoomSelected = (roomId) => {
  selectedRoomId.value = roomId;
};

const handleRoomDeselected = () => {
  selectedRoomId.value = null;
};
</script>

